module.exports = __webpack_public_path__ + "static/media/physics-che-big-mobile.10c5dc3b.png";